<template>
	<div v-loading.fullscreen.lock="loading" @click="catchFocus">
		<el-tabs v-model="activeName" type="card">
			<el-tab-pane label="扫码方式" name="扫码方式">
				<!-- <upload :quantity="currentQuantity" ref="upload" @updateLoading="updateLoading" @updateAllSize="updateAllSize" v-bind="$attrs" v-on="$listeners"></upload> -->
        <scan :quantity="currentQuantity" ref="scan" @updateLoading="updateLoading" @updateAllSize="updateAllSize" v-bind="$attrs" v-on="$listeners" :showFields="showFields.concat(['操作'])"></scan>
			</el-tab-pane>
      <el-tab-pane label="手动勾选" name="手动勾选">
        <selected  ref="selected" @updateLoading="updateLoading" @updateAllSize="updateAllSize" :quantity="currentQuantity" v-bind="$attrs" v-on="$listeners" :showFields="showFields"></selected>
      </el-tab-pane>
		</el-tabs>
		<div class="operate-buttons">
			<p class="info-tip">*批量操作可能需要较长时间，请耐心等待</p>
			<el-button type="primary" @click="submit" >提 交</el-button>
			<el-button @click="close" :disabled="loading" type="primary" plain>返 回</el-button>
		</div>
	</div>
</template>
<script>
// import upload from './upload'
import selected from './selected'
import scan from './scan'
export default {
  name: 'process-dialog',
  props: {
    quantity: {
      type: [String]
    }
  },
  components: {
    scan,
    selected
  },
  data () {
    return {
      loading: false,
      notificeRefresh: false,
      activeName: '扫码方式',
      showFields: ['样本条码号', '受检人', '性别', '样本类型', '实验室检测平台', '检测套餐', '生产条码号']
    }
  },
  computed: {
    currentQuantity () {
      return this.quantity
    }
  },
  methods: {
    catchFocus (e) {
      document.querySelector('.scan-input').focus()
    },
    submit () {
      // this.loading = true
      if (this.activeName === '扫码方式') {
        // this.$refs.upload.uploadSubmit()
        this.$refs.scan.scanSubmit()
      } else {
        this.$refs.selected.selectedSubmit()
      }
    },
    close () {
      this.$router.push('/gene-lab-order')
    },
    // visibleHandle (val) {
    //   this.notificeRefresh && this.$emit('refresh')
    //   this.$emit('update:dialogVisible', val)
    // },
    // close () {
    //   this.notificeRefresh && this.$emit('refresh')
    //   this.$emit('update:dialogVisible', false)
    // },
    updateLoading (val) {
      this.loading = val
      this.$emit('getCurrentStatusTotal')
      this.$refs.selected.reload()
    },
    updateAllSize (val) {
      this.$emit('updateAllSize', val)
    }
  }
}
</script>
<style lang="less">
</style>
